<template>
	<div>Route Suffix UUID Not Found or Type Not Supported</div>
</template>

<script>
export default {
	name: 'not-found'
}
</script>